import { render, staticRenderFns } from "./WorkGroup.vue?vue&type=template&id=1b8a84a0&scoped=true&"
import script from "./WorkGroup.vue?vue&type=script&lang=js&"
export * from "./WorkGroup.vue?vue&type=script&lang=js&"
import style0 from "./WorkGroup.vue?vue&type=style&index=0&id=1b8a84a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a84a0",
  null
  
)

export default component.exports